import React, { useState, useEffect } from "react";
import cx from "classnames";
import styles from "../scss/AppFormField.module.scss";
import { IAnswerProps } from "../interfaces/IAppFormData";
import TextField from "@material-ui/core/TextField";
import { formatDate } from "../shared/AppFormHelper";
import ValidationMessage from "../../common/components/Forms/ValidationMessage/ValidationMessage";
import { useAppFormUtils } from "../hooks/useAppFormUtils";

interface IAFDateInputProps {
    question: any;
    answerChanges: (answerParam: IAnswerProps) => void;
    inputRef?: React.Ref<HTMLTextAreaElement>;
}

const AFDateInput: React.FC<IAFDateInputProps> = (props) => {
    const { question, answerChanges } = props;

    const [dateValue, setDateValue] = useState("");
    const [isError, setIsError] = useState("");

    const { validDOB } = useAppFormUtils();

    const handleFieldValue = (date: string): void => {
        setDateValue(date);
        const dateValid = validDOB(question, date);
        setIsError(dateValid);
        answerChanges({
            questionId: question.id,
            answer: dateValid ? "" : date,
            disclosure: []
        });
    };

    const handleInitialValue = (answer: string): void => {
        if (answer) {
            const value = formatDate(new Date(answer));
            handleFieldValue(value);
        }
    };

    useEffect(() => {
        if (question?.answer) {
            handleInitialValue(question?.answer);
            return;
        }
        answerChanges({
            questionId: question.id,
            answer: "",
            disclosure: []
        });
    }, []);

    return (
        <div
            className={cx(
                styles["af-date-input"],
                Boolean(isError) ? styles["error"] : ""
            )}
            id={question.id}>
            <TextField
                id={question?.questionLabel || question?.questionText}
                name={question?.questionLabel || question?.questionText}
                type="date"
                placeholder="Date"
                value={dateValue}
                className={styles["af-datepicker"]}
                onChange={(e) => {
                    handleFieldValue(e.target.value);
                }}
                InputLabelProps={{
                    shrink: true
                }}
                inputRef={props.inputRef}
            />
            {Boolean(isError) && <ValidationMessage>{isError}</ValidationMessage>}
        </div>
    );
};

export default AFDateInput;
